import { css } from "lit";

export const fieldWrapperStyles = css`
  .field-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .field-wrapper .title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--sds-size-space-200);
    margin-bottom: var(--sds-size-space-400);
  }

  ::slotted(label.label) {
    color: var(--sds-color-text-default-default);
    font:
      var(--sds-typography-weight-medium) var(--sds-typography-body-size-large) / 100%
        var(--sds-typography-family-title),
      sans-serif;
  }

  ::slotted(span.help-text) {
    color: var(--sds-color-text-default-tertiary);
    font:
      var(--sds-typography-weight-regular) var(--sds-typography-body-size-medium) / 100%
        var(--sds-typography-family-title),
      sans-serif;
  }

  .field-wrapper .control {
    position: relative;
  }

  /* ✅ Slotted error message outside of control/title */
  ::slotted(.error-message) {
    color: var(--sds-color-text-danger-secondary);
    font:
      var(--sds-typography-weight-medium) var(--sds-typography-body-size-small) / 100% var(--sds-typography-family-body),
      sans-serif;
    margin-top: var(--sds-size-space-200);
  }

  /* ✅ Slotted info message with same font as error message */
  ::slotted(.info-message) {
    color: var(--sds-color-text-default-secondary);
    font:
      var(--sds-typography-weight-medium) var(--sds-typography-body-size-small) / 100% var(--sds-typography-family-body),
      sans-serif;
    margin-top: var(--sds-size-space-200);
  }

  .field-wrapper.radio,
  .field-wrapper.checkbox,
  .field-wrapper.switch {
    flex-direction: row;
    gap: var(--sds-size-space-400);

    .control {
      order: 1;
    }

    .title {
      order: 2;
      margin-bottom: 0;
    }
  }

  .control {
    display: flex;
  }

  .field-wrapper.radio {
    margin-bottom: var(--sds-size-space-400);
  }

  .field-wrapper.switch {
    justify-content: space-between;
    flex-direction: row-reverse;
  }
`;
